/** A row in a GroupedBarChart: a group, or a category inside one. */
export interface GroupedBarRow {
  id: string;
  kind: "group" | "category";
  /** The row's group: itself, for a group row. */
  groupId: string;
  label: string;
}

/** A group row, with the category rows it expands to show. */
export type GroupedBarGroup<Row extends GroupedBarRow> = Row & {
  kind: "group";
  categories: Row[];
};

/** The rows to draw: every group, followed by its categories when expanded. */
export function visibleBarRows<Row extends GroupedBarRow>(
  groups: GroupedBarGroup<Row>[],
  expandedGroupIds: ReadonlySet<string>,
): Row[] {
  return groups.flatMap(({ categories, ...group }) =>
    expandedGroupIds.has(group.id)
      ? [group as unknown as Row, ...categories]
      : [group as unknown as Row],
  );
}
